import { CCPA_SUBDIVISION, GDPR_WEB_LOCALES } from '@/constants/web-locales.constant';
import type { WebLocale } from '@/enums/web-locale';

import { USER_GEO_LOCATION } from '@/helpers/geo-location-helper';

function hasUCConsentBanner(webLocale: WebLocale) {
	return GDPR_WEB_LOCALES.includes(webLocale) || hasCCPABanner();
}

function hasCCPABanner() {
	return CCPA_SUBDIVISION.includes(USER_GEO_LOCATION);
}

export { hasUCConsentBanner, hasCCPABanner };
